// Pure formatting helpers shared across the Search page and its components.

import type { SearchResult } from './types';

export function capitalize(s: string): string {
  return s.replace(/[_-]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('en-NZ', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return iso;
  }
}

/** Address lines shown in a result's meta row. */
export function getSearchResultGeoLines(result: SearchResult): string[] {
  const gc = result.geographical_context;
  const lines: string[] = [];
  for (const a of gc?.addresses ?? []) {
    const fa = a?.formatted_address?.trim();
    if (fa) lines.push(fa);
  }
  const fs = gc?.street?.formatted_street?.trim();
  if (fs) lines.push(fs);
  return lines;
}
